export type InventoryObjectNameItem = {
  id: number | string
  name?: string | null
}

/**
 * Форматирует элементы инвентаризации в строку вида «id. name» через запятую.
 * Пустое или отсутствующее имя заменяется на «—».
 *
 * @param items список элементов `{ id, name }`
 */
export const formatInventoryObjectNames = (items: InventoryObjectNameItem[]): string =>
  items.map(({ id, name }) => `${id}. ${String(name ?? '').trim() || '—'}`).join(', ')
